import { DefaultValues } from 'react-hook-form'
import { boolean, InferType, mixed, object, string } from 'yup'

import { AdditionalDriverItem } from 'directFlow/state'
import { requiredMessage } from 'directFlow/state/config/content'
import { Page } from 'directFlow/types'

import { PreviousInsuranceCancellationReasons } from 'types'

export const previousCancellationDefaultValues = {
  previousInsuranceCancelled: undefined,
  wasCancelledByPolicyOwner: undefined,
  previousInsuranceCancelledReason: undefined,
} satisfies DefaultValues<PreviousCancellationSchemaType>

const cancellationReasonValidation = () =>
  mixed<PreviousInsuranceCancellationReasons>().oneOf(
    Object.values(PreviousInsuranceCancellationReasons).filter(
      (val) => val !== PreviousInsuranceCancellationReasons.ADDITIONAL_DRIVER_CANCELLED,
    ),
    requiredMessage,
  )

export const previousCancellationSchema = object({
  previousInsuranceCancelled: boolean().required(requiredMessage),
  wasCancelledByPolicyOwner: boolean().when(
    ['previousInsuranceCancelled', `$${Page.DRIVERS}.additionalDrivers.list`],
    {
      is: (previousInsuranceCancelled: boolean, additionalDrivers: AdditionalDriverItem[]) =>
        previousInsuranceCancelled && additionalDrivers.length > 0,
      then: () => boolean().required(requiredMessage),
      otherwise: () => boolean().nullable().optional(),
    },
  ),
  previousInsuranceCancelledReason: cancellationReasonValidation().when(
    [
      'previousInsuranceCancelled',
      'wasCancelledByPolicyOwner',
      `$${Page.DRIVERS}.additionalDrivers.list`,
    ],
    {
      is: (
        previousInsuranceCancelled: boolean,
        wasCancelledByPolicyOwner: boolean,
        additionalDrivers: AdditionalDriverItem[],
      ) =>
        (previousInsuranceCancelled && additionalDrivers.length === 0) ||
        (previousInsuranceCancelled && wasCancelledByPolicyOwner),
      then: () => cancellationReasonValidation().required(requiredMessage),
      otherwise: () => string().nullable().optional(),
    },
  ),
})

export type PreviousCancellationSchemaType = InferType<typeof previousCancellationSchema>
